export interface CountdownValue {
  text: string;
  urgent: boolean;
  ended: boolean;
}

const SECOND_MS = 1_000;
const MINUTE_SECONDS = 60;
const HOUR_SECONDS: number = 60 * MINUTE_SECONDS;
const DAY_SECONDS: number = 24 * HOUR_SECONDS;
const URGENT_SECONDS: number = 10 * MINUTE_SECONDS;

function padTwo(value: number): string {
  return String(value).padStart(2, '0');
}

export function formatCountdown(remainingMs: number): CountdownValue {
  if (!Number.isFinite(remainingMs) || remainingMs <= 0) {
    return { text: 'Ended', urgent: false, ended: true };
  }

  // A countdown should not show the next second until that second has fully
  // elapsed. Effects run a fraction after paint, so flooring here would make
  // an exact server-supplied remainder lose one second immediately.
  const totalSeconds = Math.ceil(remainingMs / SECOND_MS);

  if (totalSeconds >= DAY_SECONDS) {
    const days = Math.floor(totalSeconds / DAY_SECONDS);
    const hours = Math.floor((totalSeconds % DAY_SECONDS) / HOUR_SECONDS);
    const minutes = Math.floor((totalSeconds % HOUR_SECONDS) / MINUTE_SECONDS);
    return { text: `${days}d ${hours}h ${minutes}m`, urgent: false, ended: false };
  }

  const hours = Math.floor(totalSeconds / HOUR_SECONDS);
  const minutes = Math.floor((totalSeconds % HOUR_SECONDS) / MINUTE_SECONDS);
  const seconds = totalSeconds % MINUTE_SECONDS;
  return {
    text: `${hours}:${padTwo(minutes)}:${padTwo(seconds)}`,
    urgent: totalSeconds <= URGENT_SECONDS,
    ended: false,
  };
}
